import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { sentryEntityContent } from './SentryEntityContent';

/**
 * In-house Sentry entity tab, replacing the stock
 * @backstage-community/plugin-sentry tab (disabled in app-config.yaml). The
 * stock tab fetched a 24h window and defaulted its picker to 24H, disagreeing
 * with the Home "Sentry issues" panel (14 days) — ours fetches a 14-day window
 * and defaults to 14D so the two surfaces match. The pluginId 'regask-sentry'
 * keeps its extension id (entity-content:regask-sentry/sentry-issues) out of
 * the stock 'sentry' namespace so the stock disable doesn't catch it. Kept in
 * sync with app-config.yaml by sentryExtension.test.ts.
 */
export const regaskSentryPlugin = createFrontendPlugin({
  pluginId: 'regask-sentry',
  extensions: [sentryEntityContent],
});
